<template>
  <!--  <form autocomplete="on" v-on:keydown.enter="signIn" >-->
  <form v-on:keydown.enter="enterHit">
    <div class="container">
      <div class="row ">
        <div class="col">
        </div>
        <div class="col-auto">
          <div style="display: block; width: 140px">
            <select v-model="lang" class="form-control" ref="langSelect" @change="reloadLang"
                    :aria-label="$tr('signin.lang-select-hint', 'Select interface language')">
              <option v-for="langCode in langs" :value="langCode">{{ langNames[langCode] }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row" v-if="hasInvitation">
        <div class="col-12 text-center" style="font-size: 15px; max-height: 65px">
          <div class="alert alert-info" v-if="invitation">
            {{ $tr('signin.alert-invitation-sign-in', "You received an invitation from #{1}. You can connect this contact after logging in.", invitation.companyName) }}
          </div>
          <div class="alert alert-info" v-if="!invitation && !invitationError">
            {{ $tr('signin.alert-invitation-info', 'We are checking you invitation...') }}
          </div>
          <div class="alert alert-warning" v-if="invitationError">
            {{ $tr('signin.alert-invitation-warning', 'Your invitation has expired') }}
          </div>
        </div>
      </div>

      <div class="row ">
        <div class="col text-center">
          <div v-if="azureSignInEnabled" class="mb-1 mt-2 mt-lg-0">
            <button type="button" class="gsi-material-button" @click="signInWithMsBtnClick" style="width: 213px">
              <div class="gsi-material-button-state"></div>
              <div class="gsi-material-button-content-wrapper">
                <div class="gsi-material-button-icon">

                  <svg height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
                    <title>
                      MS-SymbolLockup</title>
                    <rect fill="#f25022" height="9" width="9" x="0" y="0"/>
                    <rect fill="#00a4ef" height="9" width="9" x="0" y="10"/>
                    <rect fill="#7fba00" height="9" width="9" x="10" y="0"/>
                    <rect fill="#ffb900" height="9" width="9" x="10" y="10"/>
                  </svg>

                </div>
                <span class="gsi-material-button-contents">Continue with Microsoft</span>
                <span style="display: none;">Continue with Microsoft</span>
              </div>
            </button >
          </div>


          <div v-if="googleSignInEnabled" class="mb-3 mt-2 mt-lg-0">
            <button type="button" class="gsi-material-button" @click="signInWithGoogleBtnClick" style="width: 213px">
              <div class="gsi-material-button-state"></div>
              <div class="gsi-material-button-content-wrapper">
                <div class="gsi-material-button-icon">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                       xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                    <path fill="#EA4335"
                          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                    <path fill="#4285F4"
                          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                    <path fill="#FBBC05"
                          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                    <path fill="#34A853"
                          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                    <path fill="none" d="M0 0h48v48H0z"></path>
                  </svg>
                </div>
                <span class="gsi-material-button-contents">Continue with Google</span>
                <span style="display: none;">Continue with Google</span>
              </div>
            </button>

          </div>

          <h5 style="font-weight: bold">{{ $tr("signin.or", "or") }}</h5>
          <h5 style="font-weight: bold">{{ $tr("signin.signin-email-v3", "Sign in using email") }}</h5>
        </div>


      </div>

      <div :class="{'row': true, 'mb-0': hasInvitation, 'mb-2': !hasInvitation}">

        <div class="col-12">

          <div :class="stage === 'login' ? '' : 'd-none'">
            <div class="form-group" :style="invitationStyle">
              <input
                  ref="inputLogin"
                  type="text"
                  name="username"
                  class="form-control"
                  id="loginControl"
                  autocomplete="username"
                  data-test-path="signin-email"
                  v-model="form.email"
                  @keyup="checkEmail"
                  @blur="checkEmail"
                  :disabled="stageSwitch"
                  :placeholder="$tr('signin.enter-login/email','Enter Login/email address')"
              >
              <div class="validator-messages">
                <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
              </div>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="form.checkboxRememberStatus"
                     id="rememberMeCheckbox">
              <label v-if="!checkIsCordova" class="form-check-label" for="rememberMeCheckbox">
                {{ $tr('signin.remember-mail', 'Remember my login/email') }}
              </label>
              <label v-else class="form-check-label" for="rememberMeCheckbox">
                {{ $tr('signin.remember-user', 'Remember login data') }}
              </label>
            </div>
          </div>

          <div :class="stage === 'password' ? '' : 'd-none'">
            <div class="form-group" :style="invitationStyle">
              <div class="input-group">
                <input
                    ref="inputLoginRo"
                    type="text"
                    name="login-ro"
                    class="form-control"
                    id="loginControlRo"
                    autocomplete="login-ro"
                    data-test-path="signin-email-ro"
                    v-model="form.email"
                    readonly
                >

                <button
                    type="button"
                    class="btn btn-primary"
                    data-test-path="signin-btn-signin-back"
                    :disabled="form.email === '' || stageSwitch || loggedBySSo"
                    @click="goToLoginStage">
                  <font-awesome-icon icon="pen"></font-awesome-icon>
                </button>

              </div>
              <div class="validator-messages">
                <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
              </div>
            </div>


            <div class="form-group" :style="invitationStyle" v-if="organizationsList && organizationsList.length > 1">
              <div data-test-path="org-select" class="input-container">
                <select ref="orgSelect" v-model="selectedOrganization" class="form-control" @change="orgChanged">
                  <option v-for="org in organizationsList" :key="org.id" :value="org.name">
                    {{ org.name }}
                  </option>
                </select>

              </div>
            </div>

            <div class="form-group" :style="invitationStyle" v-if="!loggedBySSo">
              <label for="passwordControl">{{ $tr('signin.password', 'Password') }}</label>
              <div class="input-group">
                <input
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    class="form-control"
                    id="passwordControl"
                    data-test-path="signin-password"
                    autocomplete="current-password"
                    aria-describedby="password-constraints"
                    v-model="form.password"
                    ref="inputPassword"
                    @keyup="checkPassword"
                    @blur="checkPassword"
                    :placeholder="$tr('signin.enter-password','Enter password')">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" @click="togglePasswordVisibility">
                    <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                  </button>
                </div>
              </div>
              <div class="validator-messages">
                <small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col justify-content-center text-center">
          <button
              v-if="stage==='password' && !this.loggedBySSo"
              type="button"
              class="btn btn-primary"
              data-test-path="signin-btn-signin"
              :disabled="(!this.loggedBySSo || inProgres) &&
            (hasErrors
            || form.email === ''
            || form.password === ''
            || loginSuccess
            || inProgres)"
              @click="signIn()">
            {{ $tr("signin.signin", "Sign In") }}
          </button>
          <button
              v-else-if="!loggedBySSo"
              type="button"
              class="btn btn-primary"
              data-test-path="signin-btn-signin-stage1"
              :disabled="!form.email"
              @click="goToPasswordStage">
            {{ $tr("signin.signin-next", "Continue using email") }}
          </button>
          <h5 v-else-if="loggedBySSo">
            {{ $tr("signin.signin-sso-in-progres", "We are moving you to your account...") }}

          </h5>
        </div>

      </div>

      <div class="row">
        <div class="col-12 general-feedback"
             style="display: flex; flex-direction: column; align-items: center; text-align: center;">
          <span v-if='loginSuccess' class="text-success">{{ $tr('signin.info-correct', 'Welcome Back') }}</span>
          <span v-if='loginFailed'
                class="text-danger">{{ $tr('signin.info.wrong', 'Invalid organization / name / password') }}</span>
          <span v-if='deactivated' class="text-danger">{{ generalFeedback }}</span>
          <span v-if="inProgres" class="text-success">{{ $tr('signin.loading', 'Logging in...') }}<b-spinner
              variant="success" :label="$tr('signin.loading','Logging in...')"></b-spinner></span>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <router-link data-test-path="forgot-password" to="/forgot-password">
            {{ $tr('signin.forgot', 'Forgot your password?') }}
          </router-link>
        </div>
      </div>

      <div class="row my-3" v-if="checkIsCordova">
        <div class="col-12 general-feedback justify-content-start">
          <v-switch :is-active="isActive" @update:is-active="isActive = $event" @click="changeState" front_label="Cert"
                    back_label="Prod"></v-switch>
        </div>
      </div>

    </div>
  </form>
</template>

<script>

import Client from "@/utils/Client";
import Rpc from "@/Rpc";
import SessionManager from "@/utils/SessionManager";
import RpcMustWaitException from "@/server/com/silkplm/rpc/RpcMustWaitException";
import InputLock from "@/utils/InputLock";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import OrganizationDeletedException from "@/server/com/silkplm/rpc/exceptions/OrganizationDeletedException";
import vSwitch from "@/components/inputs/vSwitch.vue";
import {getInviteInfo, hasPendingInvite} from "@/invitations/invites";
import OnlineDetector from "@/utils/OnlineDetector";
import {getAvailableUserConnections, isLocalStandalone, switchServer} from "@/components/subscriptions/Subs";
import {googleSignIn, googleSignInEnabled} from "@/components/sso/google";
import DialogManager from "@/utils/DialogManager";
import signIn from "@/components/SignIn.vue";
import {sendEvent} from "@/utils/GEvents";
import {azureSignIn, azureSignInEnabled} from "@/components/sso/azure";


export default {
  name: "SignInForm",

  components: {
    vSwitch
  },

  created() {
    // window.addEventListener('beforeunload', this.storeInputsValueByCheckbox);
    // this.storeInputsValueByCheckbox();

    this.form.email = window.localStorage.getItem('email');
    this.form.organization = window.localStorage.getItem('organization');
    //this.form.password = window.localStorage.getItem('password');
    if (window.isCordova) {
      if (!window.cordovaUrl.includes("cert")) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    }

  },

  mounted() {
    this.observePasswordField();

    this.hasInvitation = hasPendingInvite();
    getInviteInfo().then(data => {
      this.invitation = data;
      if (!data) {
        this.invitationError = true;
      }
    })
    if (this.form.email) {
      this.goToPasswordStage();
    } else {
      this.focusInput();
    }
    this.$nextTick(() => {

    });
  },
  beforeDestroy() {
    this.observer?.disconnect();
  },
  watch: {
    'errors': {
      handler(newValue, oldValue) {
        this.hasErrors = Object.values(oldValue).some(val => val);
      },
      deep: true
    },
    // SessionManager: function (value) {
    //   this.offline = SessionManager.offlineMode;
    // },
    // 'SessionManager.offlineMode': function (value) {
    //   this.offline = SessionManager.offlineMode;
    // }
    'SessionManager.offlineMode': function (newVal, oldVal) {
      console.log(`offlineMode changed from ${oldVal} to ${newVal}`);
    }
  },
  computed: {
    checkIsCordova() {
      return window.isCordova;
    },
    invitationStyle() {
      return {
        height: this.hasInvitation ? '65px' : '65px'
      }
    },

    invitationStyleM() {
      return {
        marginBottom: this.hasInvitation ? '2px' : '0.5rem'
      }
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    observePasswordField() {
      const input = this.$refs.inputPassword;

      const observer = new MutationObserver(() => {
        this.form.password = input.value;
        this.onPasswordChange();
      });
      this.observer = observer;

      observer.observe(input, {attributes: true, attributeFilter: ["value"], subtree: false, childList: false});

      this.$nextTick(() => {
        if (input.value) {
          this.form.password = input.value;
          this.onPasswordChange();
        }
      });
    },

    onPasswordChange() {
      const input = this.$refs.inputPassword;
      this.form.password = input.value;
      this.checkPassword();
    },

    signInWithMsBtnClick(){
      azureSignIn();
    },
    signInWithGoogleBtnClick() {
      googleSignIn();
    },

    orgChanged() {
      this.form.organization = this.selectedOrganization;
      for (let org of this.organizationsList) {
        if (org.name === this.selectedOrganization) {
          switchServer(org['server_name']);
          return;
        }
      }
      this.form.organization = "";
      this.selectedOrganization = null;
    },

    signInWithGoogleId(loginData, orgs) {
      this.stage = "password";
      this.loggedBySSo = true;
      this.form.email = loginData.email;

      if (orgs?.length) {
        this.organizationsList = orgs;
        this.form.organization = this.selectedOrganization = this.organizationsList[0].name;
      } else {
        this.organizationsList = [];
        this.selectedOrganization = "";
        this.form.organization = "";
      }
      this.orgChanged();
      this.ssoData = loginData;

      if (orgs.length > 1) {
        this.$nextTick(() => {
          this.$refs.orgSelect.focus();
        });
      } else {
        this.signIn();
      }
    },

    async goToPasswordStage() {
      this.stageSwitch = true;
      try {
        let orgs = await getAvailableUserConnections(this.form.email);
        if (orgs['server_name']) {
          switchServer(orgs['server_name']);
          this.form.organization = "";
          this.organizationsList = [];
          this.orgChanged();
          this.stage = "password";
          this.$nextTick(() => {
            this.$refs.inputPassword.focus();
          });

        } else {
          this.organizationsList = orgs['organizations']
          if (this.organizationsList.length) {
            this.form.organization = this.selectedOrganization = this.organizationsList[0].name;
          } else {
            this.form.organization = '';
          }
          this.orgChanged();
          this.stage = "password";
          this.$nextTick(() => {
            this.$refs.inputPassword.focus();
            setTimeout(() => {
              if (this.$refs.inputPassword?.value) {
                this.form.password = this.$refs.inputPassword?.value;
                this.onPasswordChange();
              }
            }, 100);
          });

        }
      } finally {
        this.stageSwitch = false;
      }
    },
    enterHit() {
      if (this.stage === "password") {
        this.signIn();
        return;
      }
      if (this.form.email) {
        this.goToPasswordStage();
      }
    },
    goToLoginStage() {
      try {
        this.loggedBySSo = false;
        this.ssoData = null;

        this.stage = "login";
        this.$nextTick(() => {
          this.$refs.inputLogin.focus();
        });
      } finally {
      }
    },
    reloadLang(val) {
      if (AppTranslations.selectedLang !== val) {
        AppTranslations.switchLang(this.lang);
      }
    },
    change() {
      console.log("change");
      this.t = !this.t;
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.inputLogin.focus();
      });
    },

    async signIn() {
      let user = null;
      this.loginFailed = false;
      this.loginSuccess = false;
      this.deactivated = false;
      this.inProgres = true;
      try {
        await OnlineDetector.detect();
        // console.log("0")
        if (SessionManager.offlineMode) {
          await this.signInOffline();
          return;
        }

        // Online login process
        Client.lockDuringNextRequest();
        if (this.ssoData) {
          if (!this.organizationsList?.length) {
            try {
              user = await Rpc.Session.signInWithSSODetectOrg(this.ssoData.token);
            } catch (e) {
              Log.fatal("signInWithSSODetectOrg failed: " + this.ssoData.email);
              DialogManager.errorNotification(e);
              this.generalFeedback = $tr('signin.error-server', 'Server error - please try again in few minutes');
              this.textColor = 'text-danger';
              this.inProgres = false;
              this.loginFailed = true;
              return;
            }
            sendEvent("signin-sso");

          } else {
            try {
              user = await Rpc.Session.signInWithSSO(this.form.organization, this.ssoData.token);
            } catch (e) {
              Log.fatal("signInWithSSO failed: " + this.ssoData.email);
              DialogManager.errorNotification(e);
              this.generalFeedback = $tr('signin.error-server', 'Server error - please try again in few minutes');
              this.textColor = 'text-danger';
              this.inProgres = false;
              this.loginFailed = true;
              return;
            }
            sendEvent("signin-sso");
          }
        } else {
          user = await Rpc.Session.signIn(this.form.organization, this.form.email, this.form.password);
          sendEvent("signin-email");
        }
        this.textColor = 'text-success';
        this.loginSuccess = true;
        this.inProgres = false;

        if (!RpcClass.csrfToken) {
          RpcClass.csrfToken = user.csrfToken;
        }
        if (user.organizationSetupProgress !== "complete") {
          this.$emit("signupInProgress", user);
          return;
        }

        await SessionManager.installRuntimeCode();

        if (!window.isCordova) {
          await this.storeInputsValueByCheckbox(this.form.organization, this.form.email);
        } else {
          await this.storeInputsValueByCheckboxIfIsCordova(this.form.organization, this.form.email, this.form.password);
        }

        let userInfo = await Rpc.Users.getSessionUserInfo();

        if (userInfo.shouldChangePassword) {
          await DialogManager.getChangePasswordDialog();
        }

        // Save credentials and user info to local storage
        localStorage.setItem('userCredentials', JSON.stringify({
          organization: this.form.organization,
          email: this.form.email,
          password: this.form.password,
          userInfo: userInfo,
          user: user
        }));


      } catch (e) {
        if (e instanceof RpcMustWaitException) {
          let lock = new InputLock();
          lock.lock();
          setTimeout(() => {
            lock.release();
            this.signIn();
          }, 2000);
        } else if (e instanceof RpcInputValidationException) {
          this.generalFeedback = e.errorMessage;
          this.textColor = 'text-danger';
          this.inProgres = false;
          this.deactivated = true;
        } else if (e instanceof OrganizationDeletedException) {
          await DialogManager.info($tr('signin.org-info-removed', 'Organization has been removed'), $tr('signin.org-info-contact', 'Please contact the owner of the organization'));
          this.textColor = 'text-danger';
          this.inProgres = false;
          this.loginFailed = true;
        } else {
          this.generalFeedback = $tr('signin.error-server', 'Server error - please try again in few minutes');
          this.textColor = 'text-danger';
          this.inProgres = false;
          this.loginFailed = true;
        }
        return;
      }

      if (!window.isCordova) {
        await this.storeInputsValueByCheckbox(this.form.organization, this.form.email);
      } else {
        await this.storeInputsValueByCheckboxIfIsCordova(this.form.organization, this.form.email, this.form.password);
      }

      if (user.organizationSetupProgress !== "complete") {

        return;
      }
      await SessionManager.preSignIn();
      SessionManager.setUserInfo(user);
      await SessionManager.postSignIn();
      EventBus.$emit(Events.organizationLogoChanged);
    },

    async signInOffline() {
      // console.log("1")
      // Try to log in using local storage
      const storedCredentials = JSON.parse(localStorage.getItem('userCredentials'));
      if (storedCredentials &&
          storedCredentials.organization === this.form.organization &&
          storedCredentials.email === this.form.email &&
          storedCredentials.password === this.form.password) {

        user = await Rpc.Session.signIn(storedCredentials.organization, storedCredentials.email, storedCredentials.password);

        this.loginSuccess = true;
        this.inProgres = false;
        this.textColor = 'text-success';
        user = storedCredentials.userInfo;
        await SessionManager.installRuntimeCode();

        if (user.shouldChangePassword) {
          await DialogManager.getChangePasswordDialog();
        }

      } else {
        this.generalFeedback = $tr('signin.error-offline-credentials', 'Offline credentials are incorrect');
        this.textColor = 'text-danger';
        this.inProgres = false;
        this.loginFailed = true;
      }
    },
    checkEmail() {

      setTimeout(() => {
        this.errors.email = null;

        if (this.form.email === '' || this.form.email === null) {
          this.errors.email = "";
          return;
        }

        if (!this.form.email.includes("@")) {
          this.errors.email = $tr('signin.invalid-email', 'Email has invalid format');
        }
      }, 500);

    },

    checkPassword() {

      setTimeout(() => {
        this.errors.password = null;

        if (this.form.password === '' || this.form.password === null) {
          this.errors.password = $tr("signin.empty-password", "Password FIELD can't be empty");
        }
      }, 500);

    },

    async storeInputsValueByCheckbox() {
      if (this.form.checkboxRememberStatus === true) {
        if (this.form.email) {
          window.localStorage.setItem('email', this.form.email);
        }
        if (this.form.organization) {
          window.localStorage.setItem('organization', this.form.organization);
        }
      } else {
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('organization');
        window.localStorage.removeItem('password');
      }
    },
    async storeInputsValueByCheckboxIfIsCordova() {
      if (this.form.checkboxRememberStatus === true) {
        if (this.form.email) {
          window.localStorage.setItem('email', this.form.email);
        }
        if (this.form.organization) {
          window.localStorage.setItem('organization', this.form.organization);
        }
        if (this.form.password) {
          window.localStorage.setItem('password', this.form.password);
        }
      } else {
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('organization');
        window.localStorage.removeItem('password');
      }
    },
    changeState(isActive) {
      this.isActive = !isActive;
      if (this.isActive === true) {
        window.cordovaUrl = "https://silkplm.com";
        window.localStorage.setItem('cordovaURL', window.cordovaUrl);
        if (navigator.app) {
          navigator.app.exitApp();
        } else if (navigator.device) {
          navigator.device.exitApp();
        } else {
          // Dodatkowe obsługi dla różnych wersji Cordova lub platformy
          console.log("Nie można zamknąć aplikacji");
        }
      } else {
        window.cordovaUrl = "https://cert.silkplm.com";
        window.localStorage.setItem('cordovaURL', window.cordovaUrl);
        if (navigator.app) {
          navigator.app.exitApp();
        } else if (navigator.device) {
          navigator.device.exitApp();
        } else {
          // Dodatkowe obsługi dla różnych wersji Cordova lub platformy
          console.log("Nie można zamknąć aplikacji");
        }
      }
      // let url = `${window.cordovaUrl}/dashboard/`;
      // let target = '_self'; // Otwórz w bieżącym widoku Cordova
      // let options = 'location=yes'; // Pokaż pasek adresu
      //
      // cordova.InAppBrowser.open(url, target, options);

    }
  },
  data: function () {
    return {
      googleSignInEnabled: googleSignInEnabled(),
      azureSignInEnabled: azureSignInEnabled(),
      brokerMode: !isLocalStandalone(),
      stageSwitch: false,
      stage: 'login',
      loggedBySSo: false,
      ssoData: null,
      showPassword: false,
      langs: AppTranslations.langs,
      langNames: AppTranslations.langsNames,
      lang: AppTranslations.selectedLang,
      isDev: !SessionManager.isProd(),
      invitationError: false,
      inProgres: false,
      loginFailed: false,
      loginSuccess: false,
      hasInvitation: false,
      invitation: null,
      mode: 'signIn',
      hasErrors: false,
      generalFeedback: "",
      textColor: "",
      deactivated: false,
      offline: false,
      organizationsList: null,
      selectedOrganization: null,
      errors: {
        organization: null,
        email: null,
        password: null
      },
      form: {
        organization: '',
        email: '',
        password: '',
        checkboxRememberStatus: true
      },
      isActive: true,
    };
  }
}
</script>

<style lang="sass" scoped>
@import '../styles/signin-signup'

.input-group-append
  .btn:focus
    box-shadow: none
    outline: none

</style>